/**
 * @generated SignedSource<<9e31a1229f4bbee490705bb6a2ddbb67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsServiceGroupEditPageQuery$variables = {
  id: string;
};
export type SettingsServiceGroupEditPageQuery$data = {
  readonly serviceGroup: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity" | "ServiceGroupEditTabs_serviceGroup">;
  } | null;
};
export type SettingsServiceGroupEditPageQuery = {
  response: SettingsServiceGroupEditPageQuery$data;
  variables: SettingsServiceGroupEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsServiceGroupEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceGroup",
        "kind": "LinkedField",
        "name": "serviceGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ServiceGroupEditTabs_serviceGroup"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsServiceGroupEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceGroup",
        "kind": "LinkedField",
        "name": "serviceGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 2147483647
              }
            ],
            "concreteType": "ServiceConnection",
            "kind": "LinkedField",
            "name": "services",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Service",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "price",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deletable",
                            "storageKey": null
                          }
                        ],
                        "type": "Entity",
                        "abstractKey": "__isEntity"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": "services(first:2147483647)"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "851ad3613d1bd897a1053796b5e7f5a0",
    "id": null,
    "metadata": {},
    "name": "SettingsServiceGroupEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsServiceGroupEditPageQuery(\n  $id: ID!\n) {\n  serviceGroup(id: $id) {\n    name\n    ...EntitySidebar_entity\n    ...ServiceGroupEditTabs_serviceGroup\n    id\n  }\n}\n\nfragment AddServiceDialog_serviceGroup on ServiceGroup {\n  id\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment ServiceGroupEditMain_serviceGroup on ServiceGroup {\n  id\n  name\n}\n\nfragment ServiceGroupEditServices_serviceGroup on ServiceGroup {\n  services(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...ServiceRow_service\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...AddServiceDialog_serviceGroup\n}\n\nfragment ServiceGroupEditTabs_serviceGroup on ServiceGroup {\n  ...ServiceGroupEditMain_serviceGroup\n  ...ServiceGroupEditServices_serviceGroup\n}\n\nfragment ServiceRow_service on Service {\n  id\n  name\n  type\n  price\n  ...SortableEntityTableRow_entity\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "e840abd9e9ff0ba16b8a586fdb90c30b";

export default node;
